import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import {
  Opts,
  PagedResponse
} from "@ofqual/portal-core/core/types";
import { Activity } from "../domain/Activity";
import { ActivityDocument, MessageThread } from "../domain/PublicMessageModel";
import { ActivityType } from "../domain/ActivityType";

export class ThreadedMessageService extends BaseRemoteService {
  public async getPublicMessageThreads(
    citizenId: string,
    opts: Opts
  ): Promise<PagedResponse<Activity>> {
    const url = `${this.apiRoot}/activity/message-threads/${citizenId}`;
    const data = await super.getRequest<MessageThread[]>(url, opts);
    return this.mapThreadedMessages(data);
  }

  private mapThreadedMessages(
    threadedMessages: MessageThread[]
  ): PagedResponse<Activity> {
    let mappedResult = {
      page: 0,
      count: 0,
      pageSize: 100,
      data: [],
    } as PagedResponse<Activity>;

    if (threadedMessages.length > 0) {
      threadedMessages.forEach((thread) => {
        let mappedActivity = {} as Activity;

        mappedActivity.resourceId = thread.citizenId;
        mappedActivity.createdDate = thread.createdDate;
        mappedActivity.id = thread.firstMessageId;
        mappedActivity.createdByUpn = thread.createdByUpn;
        mappedActivity.resourceType = "specialists";
        mappedActivity.activityTitle = thread.threadActivityTitle;   
        mappedActivity.activityType = thread.threadActivityType;
        mappedActivity.createdByDisplayName = thread.createdByDisplayName;

        mappedActivity.activityMetaData = JSON.stringify({
          message: thread.firstMessageContent,
          subject: thread.threadSubject,
          documents: [] as ActivityDocument[],
          lastMessageDate: thread.lastMessageDate,
          messageThreadId: thread.threadId,
          messagesSentByCitizenUnreadByOfqual: thread.unreadCitizenMessagesCount,
          messagesSentByofqualUnreadByCitizen: thread.unreadOfqualMessagesCount,
          replies: thread.totalRepliesCount         
        });
        mappedResult.data.push(mappedActivity);
      });
      mappedResult.count = mappedResult.data.length;
      mappedResult.page = 0;
      mappedResult.pageSize = mappedResult.data.length;
    }
    mappedResult.data.reverse();
    return mappedResult;
  }
}

